import '../../shared/site.css';
import './home.css';
import { pages } from '../../shared/pages.js';
import { mountNav } from '../../shared/nav.js';

const list = document.querySelector('#tools');

const live = pages.filter((p) => p.status === 'live');

if (live.length === 0) {
  list.innerHTML = '<li class="empty">Nothing here yet.</li>';
} else {
  for (const page of live) {
    const li = document.createElement('li');

    const link = document.createElement('a');
    link.className = 'tool';
    link.href = `/${page.slug}`;

    const head = document.createElement('div');
    head.className = 'tool-head';

    const icon = document.createElement('span');
    icon.className = 'tool-icon';
    icon.textContent = page.icon;
    icon.setAttribute('aria-hidden', 'true');

    const title = document.createElement('h2');
    title.className = 'tool-title';
    title.textContent = page.title;

    const path = document.createElement('span');
    path.className = 'tool-path';
    path.textContent = `/${page.slug}`;

    const blurb = document.createElement('p');
    blurb.className = 'tool-blurb';
    blurb.textContent = page.blurb;

    head.append(icon, title, path);
    link.append(head, blurb);
    li.append(link);
    list.append(li);
  }
}

mountNav();
